import { createContext, useContext } from 'react'

export const UserContext = createContext<Maybe<User>>(null)

export default UserContext
export const UserConsumer = UserContext.Consumer
export const UserProvider = UserContext.Provider

export const useUserContext = () => useContext(UserContext)
